import React, { useEffect, useState, useRef } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { Avatar, CircularProgress, Tooltip } from "@mui/material";
import { get_root_value } from "src/utils/domUtils";
import { s3baseUrl } from "src/config/config";
import { editProfileApi } from "src/DAL/EditProfile/EditProfile";
import { htmlDecode } from "src/utils/convertHtml";
import { usePGIMode } from "src/Hooks/PGIModeContext";
import EditPhoto from "src/components/MenuOption/EditPhoto";
import { defaultSettingApi } from "src/DAL/SiteSetting/siteSetting";
import { useContentSetting } from "src/Hooks/ContentSettingState";

const Input = styled("input")({
  display: "none",
});

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
  paper: {
    background: get_root_value("--popup-background-color"),
    color: get_root_value("--input-text-color"),
  },
}));

function EditProfile() {
  const classes = useStyles();
  const { setProfileNewImage } = usePGIMode();
  const { handleSetUserInfo } = useContentSetting();
  const { enqueueSnackbar } = useSnackbar();
  const [previews, setPreviews] = useState("");
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setProfileImage] = useState({});
  const [imageStatus, setImageStatus] = useState(false);
  const [oldProfile, setOldProfile] = useState();
  const myInputRef = useRef(null);
  const [adminData, setAdminData] = useState({
    first_name: "",
    image: "",
    email: "",
  });

  const consultantProfile = async () => {
    const result = await defaultSettingApi();
    if (result.code === 200) {
      if (result.time_zone) {
        localStorage.setItem(
          "admin_time_zone",
          JSON.stringify(result.time_zone),
        );
      }
      handleSetUserInfo(result.adminUser);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const MENU_OPTIONS = [
    {
      label: "Update Image",
      icon: "akar-icons:edit",
      handleClick: () => {
        myInputRef.current.click();
      },
    },
    {
      label: "View Profile",
      icon: "line-md:image",
      handleClick: handleOpen,
    },
  ];

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();

    formData.append("name", adminData.first_name);
    formData.append("email", adminData.email);
    if (imageStatus) {
      formData.append("image", file);
    }
    const result = await editProfileApi(formData);
    if (result.code === 200) {
      console.log("Edit Profile  :", result);
      localStorage.setItem(`name`, result?.admin?.name);
      localStorage.setItem("email", result?.admin?.email);
      if (imageStatus) {
        localStorage.setItem(`image`, result?.admin.image?.thumbnail_1);
        setProfileNewImage(result?.admin.image?.thumbnail_1);
      }
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setIsLoading(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setAdminData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleUpload = (event) => {
    setImageStatus(true);
    setProfileImage(event.target.files[0]);
    const preview = URL.createObjectURL(event.target.files[0]);
    setPreviews(preview);
  };

  useEffect(() => {
    console.log(s3baseUrl + localStorage.getItem("image"), "dfajslkdjfa");
    setOldProfile(localStorage.getItem("image"));
    setAdminData({
      ...adminData,
      ["first_name"]: htmlDecode(localStorage.getItem("name")),
      ["email"]: htmlDecode(localStorage.getItem("email")),
    });
  }, []);

  useEffect(() => {
    consultantProfile();
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container ">
      {open && (
        <div className="image-popup">
          <span className="cross" onClick={handleClose}>
            x
          </span>
          <img
            className="image-border"
            src={previews ? previews : s3baseUrl + oldProfile}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      )}
      <form onSubmit={handleUpdate}>
        <div className="mt-4 mb-4 d-flex justify-content-center">
          <div className="cards-edit p-4">
            <div className=" image d-flex flex-column justify-content-center align-items-center">
              <div className="edit-profile-icon">
                <Avatar
                  alt={adminData.first_name}
                  src={previews ? previews : s3baseUrl + oldProfile}
                  sx={{ width: 110, height: 110 }}
                />
                <label htmlFor="icon-button-file">
                  <Input
                    accept="image/*"
                    id="icon-button-file"
                    type="file"
                    name="profile_image"
                    onChange={(e) => handleUpload(e)}
                  />

                  <IconButton
                    className="edit-profile-icon-position"
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                  ></IconButton>
                </label>

                <span
                  className="profile-image-button"
                  style={{
                    position: "absolute",
                    bottom: "31px",
                    right: "-4px",
                    borderRadius: "50%",
                    padding: "4px 5px",
                  }}
                >
                  <EditPhoto menu={MENU_OPTIONS} />
                  <input
                    hidden
                    type="file"
                    ref={myInputRef}
                    onChange={handleUpload}
                  />
                </span>
              </div>
              <div className="row w-100 mt-3">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="mt-4">
                    <TextField
                      id="outlined-basic"
                      label="Full Name"
                      variant="outlined"
                      fullWidth
                      name="first_name"
                      value={adminData.first_name}
                      onChange={(e) => handleChange(e)}
                      required={true}
                    />
                  </div>
                </div>{" "}
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <Tooltip title={"Updating Email is not Allowed!"}>
                    <div className="mt-4">
                      <TextField
                        id="outlined-basic"
                        label="Email"
                        variant="outlined"
                        fullWidth
                        name="email"
                        disabled={true}
                        value={adminData.email}
                        onChange={(e) => handleChange(e)}
                        required={true}
                      />
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="mt-2 ms-auto">
                <button className="small-contained-button mt-4 ">Update</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditProfile;
